import React, { useState } from 'react';

import { Button } from '@mui/material';
import LoaderNew from '../../../common/LoaderNew';

const SignupEmail = ({ classes, hashData, submitEmail, loading }) => {
  const [email, setEmail] = useState('');

  return (
    <div>
      <div>
        <div style={{ paddingBottom: '7px' }}>
          <span className={classes.helpText}>
            {'Your email'}
          </span>
        </div>
        {hashData.email_account ?
          <span style={{fontWeight: 'bold'}}>
            {hashData.email_account}
          </span>
        :
          <input
            label='Email'
            autoFocus 
            placeholder="email@example.com"
            className={`${classes.insetShadowInput}`}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') submitEmail(email);
            }}
          />
        }
      </div>

      <div>
        <Button
          autoFocus 
          disabled={(email === '' && !hashData.email_account) || loading}
          disableElevation
          size="small"
          variant="contained"
          className={`${classes.okBtn} ${classes.mt20} ${classes.mb30}`}
          onClick={(e) => {
            e.preventDefault();
            if (hashData.email_account) {
              submitEmail(hashData.email_account);
            } else {
              submitEmail(email);
            };
          }}
          >
          {loading ? <LoaderNew color='white'/> : 'Next'}
        </Button>
      </div>

      <div className={classes.alignJustifyCenter} style={{ padding: '0px 0px 10px 2px' }}>
        <span className={`${classes.helpText} ${classes.mr5}`}>
          Already have an account?
        </span>
        <a
          className={`${classes.helpAction}`} rel="noreferrer" href={`/auth`}>
          Login
        </a>
      </div>
    </div>
  )
};

export default SignupEmail;